import { AxiosManager } from "../axiosManager";

export function reqPaypalPayment(payload: any) {
  return AxiosManager.post(`/paypal/request`, payload);
}

export function reqPaypalRefund(payload: any) {
  return AxiosManager.post(`/paypal/handle/refund`, payload);
}
